//import firebase from 'firebase/app';
//import 'firebase/functions';
//import { getPlatforms } from '@ionic/vue';
import parentOrderService from '@/app-template/lib/services/OrderService';

export default {
  ...parentOrderService,
}